var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Component, ViewChild, Input, Inject } from '@angular/core';
import * as _ from 'lodash';
import { finalize } from 'rxjs/operators';
import { FontElementSettingModal } from '../base/font-element-setting-modal';
import { FlagDataType } from '../../core/variable/flagDateType-enum';
import { VARIABLE_SERVICE } from '../../core/variable/variable.service';
import { SecuritySettingAdapter } from '../shared/control/security-setting.adapter';
import { VariableName } from '../../core/variable/variable-name';
import { FontSizeHelper } from '../../shared/helpers/font-size-helper';
import { FontStyleHelper } from '../../shared/helpers/font-style-helper';
import { TextAlignHelper } from '../../shared/helpers/text-align-helper';
import { DynamicDisplayModel } from '../../../../shared/dynamic-conduct-model/dynamic-display/dynamic-display-model';
import { AccessPermission } from '../../../../shared/fbox/fbox/access-permission';
var CharacterSettingModalComponent = /** @class */ (function (_super) {
    __extends(CharacterSettingModalComponent, _super);
    function CharacterSettingModalComponent(injector, variableService, accessPermissionService) {
        var _this = _super.call(this, injector, 'characterModal') || this;
        _this.variableService = variableService;
        _this.dataType = FlagDataType.String;
        _this.variableTextFont = {
            content: _this.lc('ConfigureVariableName'),
            font: {
                fontSize: FontSizeHelper.defaultFontSize,
                isBold: false,
                isItalic: false,
                isUnderline: false,
                color: FontStyleHelper.defaultFontColor,
                textAlign: TextAlignHelper.AlignCenter,
                fontFamily: FontStyleHelper.defautFontFamily
            }
        };
        _this.hasCharCount = false;
        _this.accessPermissions = accessPermissionService.getAccessPermissions();
        _this.accessPermissionEnum = AccessPermission;
        return _this;
    }
    Object.defineProperty(CharacterSettingModalComponent.prototype, "currentReadVariableId", {
        get: function () {
            return this._currentReadVariableId;
        },
        set: function (v) {
            if (VariableName.equals(this._currentReadVariableId, v)) {
                return;
            }
            this._currentReadVariableId = v;
            this.currentReadVariableIdChanged();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CharacterSettingModalComponent.prototype, "currentReadVariable", {
        get: function () {
            return this._currentReadVariable;
        },
        set: function (v) {
            if (v === this._currentReadVariable) {
                return;
            }
            this._currentReadVariable = v;
            this.currentReadVariableChanged();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CharacterSettingModalComponent.prototype, "currentWriteVariableId", {
        get: function () {
            return this._currentWriteVariableId;
        },
        set: function (v) {
            if (VariableName.equals(this._currentWriteVariableId, v)) {
                return;
            }
            this._currentWriteVariableId = v;
            this.currentWriteVariableIdChanged();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CharacterSettingModalComponent.prototype, "currentWriteVariable", {
        get: function () {
            return this._currentWriteVariable;
        },
        set: function (v) {
            if (v === this._currentWriteVariable) {
                return;
            }
            this._currentWriteVariable = v;
            this.currentWriteVariableChanged();
        },
        enumerable: true,
        configurable: true
    });
    CharacterSettingModalComponent.prototype.init = function (editedComponent) {
        var _this = this;
        this.editedComponent = editedComponent;
        var componentData = editedComponent.model.data;
        this.configureId = editedComponent.configureId;
        this.setReadVariable(componentData);
        this.setWriteVariable(componentData);
        _super.prototype.init.call(this, editedComponent);
        this.loadAccessPermission(componentData);
        this.loadBasicInfo(componentData);
        this.loadIsPasswordSetting(componentData);
        this.loadIsSameVariable(componentData);
        this.loadGraphSetting(componentData);
        this.loadControlSetting(componentData);
        this.loadDynamicSetting(componentData);
        this.loadVariableText(componentData);
        setTimeout(function () {
            _this.displaySettingCmp.init(editedComponent);
            _this.enableSettingCmp.init(editedComponent);
            _this.isFirstLoadingVariableText = false;
        }, 500);
        this.modal.show();
    };
    CharacterSettingModalComponent.prototype.loadVariableText = function (componentData) {
        this.showVariableText = componentData.showVariableText ? componentData.showVariableText : false;
        if (componentData.variableText) {
            this.variableTextFont = _.cloneDeep(componentData.variableText);
            this.isFirstLoadingVariableText = true;
        }
    };
    CharacterSettingModalComponent.prototype.setReadVariable = function (componentData) {
        var _this = this;
        if (componentData.readVariableVersion) {
            this.currentReadVariableId = VariableName.tryParse(componentData.readVariableName, componentData.readVariableVersion);
        }
        else if (!_.isNil(componentData.readDataSourceCode)) {
            this.variableService.getVariableName(componentData.readDataSourceCode, componentData.readVariableName, componentData.readVariableGroupName).subscribe(function (value) {
                _this.currentReadVariableId = value;
            });
        }
    };
    CharacterSettingModalComponent.prototype.setWriteVariable = function (componentData) {
        var _this = this;
        if (componentData.writeVariableVersion) {
            this.currentWriteVariableId = VariableName.tryParse(componentData.writeVariableName, componentData.writeVariableVersion);
        }
        else if (!_.isNil(componentData.writeDataSourceCode)) {
            this.variableService.getVariableName(componentData.writeDataSourceCode, componentData.writeVariableName, componentData.writeVariableGroupName).subscribe(function (value) {
                _this.currentWriteVariableId = value;
            });
        }
    };
    CharacterSettingModalComponent.prototype.currentReadVariableIdChanged = function () {
        var _this = this;
        var variableId = this.currentReadVariableId;
        if (variableId && variableId.name) {
            this.isLoading = true;
            this.variableService.findVariable(variableId)
                .pipe(finalize(function () { _this.isLoading = false; }))
                .subscribe(function (variable) {
                if (!_this.isFirstLoadingVariableText) {
                    _this.variableTextFont.content = variableId.name ? variableId.name : '';
                }
                _this.isFirstLoadingVariableText = false;
                _this.currentReadVariable = variable;
            });
        }
        else {
            // 点击清空按钮，变成null，重置单位和变量名称文字
            if (variableId === null) {
                this.variableTextFont.content = this.lc('ConfigureVariableName');
            }
            this.isFirstLoadingVariableText = false;
            this.currentReadVariable = undefined;
        }
    };
    CharacterSettingModalComponent.prototype.currentReadVariableChanged = function () {
        var variable = this.currentReadVariable;
        if (this.isSameVariable) {
            this.toggleCharCountLabel(variable);
        }
    };
    CharacterSettingModalComponent.prototype.currentWriteVariableIdChanged = function () {
        var _this = this;
        var variableId = this.currentWriteVariableId;
        if (variableId && variableId.name) {
            this.isLoading = true;
            this.variableService.findVariable(variableId)
                .pipe(finalize(function () { _this.isLoading = false; }))
                .subscribe(function (variable) {
                _this.currentWriteVariable = variable;
            });
        }
        else {
            this.currentWriteVariable = undefined;
        }
    };
    CharacterSettingModalComponent.prototype.currentWriteVariableChanged = function () {
        var variable = this.currentWriteVariable;
        this.toggleCharCountLabel(variable);
    };
    CharacterSettingModalComponent.prototype.loadAccessPermission = function (componentData) {
        var self = this;
        if (componentData.accessPermission) {
            self.accessPermission = componentData.accessPermission;
        }
        else {
            self.accessPermission = AccessPermission.ReadOnly;
        }
    };
    CharacterSettingModalComponent.prototype.toggleCharCountLabel = function (variable) {
        if (!variable) {
            this.hasCharCount = false;
            delete this.charCountNum;
            return;
        }
        if (this.accessPermission === AccessPermission.ReadWrite) {
            this.hasCharCount = variable.charCount ? true : false;
            this.charCountNum = variable.charCount;
        }
        else {
            this.hasCharCount = false;
        }
    };
    CharacterSettingModalComponent.prototype.loadGraphSetting = function (componentData) {
        this.useGraph = componentData.useGraph;
        if (null != componentData.graphSetting) {
            this.graphSetting = _.cloneDeep(componentData.graphSetting);
        }
        else {
            this.graphSetting = {};
        }
    };
    CharacterSettingModalComponent.prototype.loadBasicInfo = function (componentData) {
        this.labelInfo = _.cloneDeep(componentData.label);
    };
    CharacterSettingModalComponent.prototype.loadControlSetting = function (componentData) {
        this.securitySettingData = new SecuritySettingAdapter(componentData, true);
    };
    CharacterSettingModalComponent.prototype.loadDynamicSetting = function (componentData) {
        if (null != componentData.dynamicSetting) {
            this.dynamicSetting = _.cloneDeep(componentData.dynamicSetting);
            DynamicDisplayModel.addDefaultForRotationTranslation(this.dynamicSetting);
        }
        else {
            this.dynamicSetting = DynamicDisplayModel.default();
        }
    };
    CharacterSettingModalComponent.prototype.loadIsPasswordSetting = function (componentData) {
        this.isPassword = componentData.isPassword ? componentData.isPassword : false;
    };
    CharacterSettingModalComponent.prototype.loadIsSameVariable = function (componentData) {
        this.isSameVariable = componentData.isSameVariable ? true : componentData.isSameVariable;
    };
    CharacterSettingModalComponent.prototype.useSameVariable = function () {
        this.isSameVariable = !this.isSameVariable;
    };
    CharacterSettingModalComponent.prototype.useIsPassword = function () {
        this.isPassword = !this.isPassword;
    };
    CharacterSettingModalComponent.prototype.save = function () {
        var self = this;
        self.saving = true;
        this.currentDiagram.startTransaction('numericalDisplay settings');
        if (this.accessPermission !== AccessPermission.ReadOnly) {
            if (!this.enableSettingCmp.save()) {
                this.saving = false;
                this.setActiveTab(2);
                return;
            }
        }
        if (!this.displaySettingCmp.save()) {
            self.saving = false;
            this.setActiveTab(3);
            return;
        }
        self.saveVariableInfo();
        self.saveVariableText();
        self.saveSameVariable();
        self.savePasswordSetting();
        self.saveAccessPermission();
        self.saveBasicInfo();
        self.saveControlSetting();
        self.saveCharCount();
        self.saveGraphSetting();
        self.saveDynamicSetting();
        this.currentDiagram.commitTransaction('numericalDisplay settings');
        self.close();
    };
    CharacterSettingModalComponent.prototype.onHidden = function () {
        this.currentReadVariableId = undefined;
        this.currentWriteVariableId = undefined;
        _super.prototype.onHidden.call(this);
    };
    CharacterSettingModalComponent.prototype.saveVariableText = function () {
        this.saveComponentProperty('showVariableText', this.showVariableText);
        this.saveComponentProperty('variableText', this.variableTextFont);
    };
    CharacterSettingModalComponent.prototype.saveVariableInfo = function () {
        this.deleteComponentProperty('readDataSourceCode');
        this.deleteComponentProperty('readVariableGroupName');
        this.saveComponentProperty('readVariableName', this.currentReadVariableId ? this.currentReadVariableId.name : '');
        this.saveComponentProperty('readVariableVersion', this.currentReadVariableId ? this.currentReadVariableId.variableVersion : undefined);
    };
    CharacterSettingModalComponent.prototype.saveSameVariable = function () {
        if (!this.isSameVariable) {
            this.deleteComponentProperty('writeDataSourceCode');
            this.deleteComponentProperty('writeVariableGroupName');
            this.saveComponentProperty('writeVariableName', this.currentWriteVariableId ? this.currentWriteVariableId.name : '');
            this.saveComponentProperty('writeVariableVersion', this.currentWriteVariableId ? this.currentWriteVariableId.variableVersion : undefined);
        }
        else {
            this.deleteComponentProperty('writeDataSourceCode');
            this.deleteComponentProperty('writeVariableName');
            this.deleteComponentProperty('writeVariableGroupName');
            this.deleteComponentProperty('writeVariableVersion');
        }
        this.saveComponentProperty('isSameVariable', this.isSameVariable);
    };
    CharacterSettingModalComponent.prototype.savePasswordSetting = function () {
        this.saveComponentProperty('isPassword', this.isPassword);
    };
    CharacterSettingModalComponent.prototype.saveAccessPermission = function () {
        if (this.accessPermission === AccessPermission.ReadOnly) {
            this.deleteComponentProperty('writeDataSourceCode');
            this.deleteComponentProperty('writeVariableName');
            this.deleteComponentProperty('writeVariableGroupName');
            this.deleteComponentProperty('isSameVariable');
        }
        this.saveComponentProperty('accessPermission', this.accessPermission);
    };
    CharacterSettingModalComponent.prototype.saveControlSetting = function () {
        this.controlSettingCmp.save(this.editedComponent.model, this.accessPermission === AccessPermission.ReadWrite);
    };
    CharacterSettingModalComponent.prototype.saveBasicInfo = function () {
        this.saveComponentProperty('label', this.labelInfo);
    };
    CharacterSettingModalComponent.prototype.saveGraphSetting = function () {
        this.saveComponentProperty('useGraph', this.useGraph);
        if (this.useGraph) {
            this.saveComponentProperty('graphSetting', this.graphSetting);
        }
        else {
            this.deleteComponentProperty('graphSetting');
        }
        this.deleteComponentProperty('graphUrl');
    };
    CharacterSettingModalComponent.prototype.saveCharCount = function () {
        if (this.accessPermission === AccessPermission.ReadWrite) {
            this.saveComponentProperty('charCount', this.charCountNum);
        }
        else {
            this.deleteComponentProperty('charCount');
        }
    };
    CharacterSettingModalComponent.prototype.saveDynamicSetting = function () {
        if (!this.dynamicValidatoinResult) {
            if (this.dynamicSetting.isTranslation !== true) {
                this.dynamicSetting.horizontalTranslation = null;
                this.dynamicSetting.verticalTranslation = null;
            }
            else {
                if (this.dynamicSetting.isHorizontalTranslation !== true) {
                    this.dynamicSetting.horizontalTranslation = null;
                }
                if (this.dynamicSetting.isVerticalTranslation !== true) {
                    this.dynamicSetting.verticalTranslation = null;
                }
            }
            if (this.dynamicSetting.isRotation !== true) {
                this.dynamicSetting.rotation = null;
            }
            this.saveComponentProperty('dynamicSetting', this.dynamicSetting);
        }
        else {
            this.notify.error(this.l('Savedfail'));
        }
    };
    CharacterSettingModalComponent.prototype.setActiveTab = function (tabId) {
        this.staticTabs.tabs[tabId].active = true;
    };
    CharacterSettingModalComponent.prototype.validateChange = function (validatoinResult) {
        this.dynamicValidatoinResult = validatoinResult;
    };
    __decorate([
        ViewChild('displaySettingCmp', { static: false })
    ], CharacterSettingModalComponent.prototype, "displaySettingCmp", void 0);
    __decorate([
        ViewChild('enableSettingCmp', { static: false })
    ], CharacterSettingModalComponent.prototype, "enableSettingCmp", void 0);
    __decorate([
        ViewChild('staticTabs', { static: false })
    ], CharacterSettingModalComponent.prototype, "staticTabs", void 0);
    __decorate([
        ViewChild('controlSettingCmp', { static: false })
    ], CharacterSettingModalComponent.prototype, "controlSettingCmp", void 0);
    __decorate([
        Input()
    ], CharacterSettingModalComponent.prototype, "viewWidth", void 0);
    __decorate([
        Input()
    ], CharacterSettingModalComponent.prototype, "viewHeight", void 0);
    CharacterSettingModalComponent = __decorate([
        Component({
            selector: 'character-setting-modal',
            styles: [".element-setting-base{ .inline-label { margin: 10px 0px 0px 10px; display: inline-block; } .border-group { // border: 1px solid #ddd; padding: 5px; margin-bottom: 0px; } .inline-selector { display: inline-block; margin: 5px 0px; } .inline-variable { display: inline-block; margin: 5px 0px; } .inline-input { display: inline-block; margin: 5px 0px; }     } .date-time-setting-modal { .modal-content { width: 600px; } .cursor-pointer{ cursor: pointer; } .recode-input{ width: calc(100% - 70px); border: 1px solid #d7dbe5;   padding:  5px 10px; } textarea.noResize { resize: none; } } .toggleViewSettingModal { .modal-content { width: 600px; } } .textSettingModal { .modal-content { width: 600px; } } ",
                " .characterModal{ .characterTypeRadio{ a{ text-decoration: none; color:inherit; } } .modal-content { width: 600px; } .display-variable-name{ line-height: 30px; } } .variable-text-input{ width: 100%; } .warning-text{ color: red; font-size: 14px; padding: 5px; } "],
            template: "<div bsModal #settingModal=\"bs-modal\" id=\"characterModal\" class=\"modal fade characterModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"settingModal\" aria-hidden=\"true\" [config]=\"{backdrop: 'static'}\" (onHidden)=\"onHidden()\"> <div class=\"modal-dialog\"> <div class=\"modal-content element-setting-base\" [busyIf]=\"isLoading\"> <div class=\"fe-modal-container\"> <form class=\"configure\" *ngIf=\"active\" #characterForm=\"ngForm\" novalidate (ngSubmit)=\"save()\"> <div class=\"modal-header fe-modal-header\"> <h4 class=\"fe-modal-header-title\"> {{lc(\"Character\")}} </h4> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"close()\">×</div> </div> <div class=\"top-line\"></div> <div class=\"fe-modal-middle design-nav-link\"> <tabset #staticTabs class=\"tab-container tabbable-line\"> <tab heading=\"{{lc('Setting')}}\" customClass=\"m-tabs__item\"> <div class=\"fe-modal-content\"> <div class=\"fe-radio-select-header\"> <label *ngFor=\"let permision of accessPermissions\"> <input type=\"radio\" name=\"accessOptions\" [value]=\"permision.key\" [(ngModel)]=\"accessPermission\" /> <span *ngIf=\"permision.value=='ReadOnly'\">{{lc('CharacterReadOnly')}}</span> <span *ngIf=\"permision.value=='ReadWrite'\">{{lc('CharacterReadWrite')}}</span> </label> </div> <div *ngIf=\"accessPermission == accessPermissionEnum.ReadOnly\"> <div class=\"fe-option-head\"> <label> <input type=\"checkBox\" (change)=\"useIsPassword()\" [checked]=\"isPassword\" /> <span>{{lc(\"Password\")}}</span> </label> </div> <div class=\"fe-modal-body\"> <div class=\"fe-vertical-label\"> <div class=\"fe-vertical-title\">{{lc(\"VariableName\")}}:</div> <variable-selector [configureId]=\"configureId\" [(currentVariableId)]=\"currentReadVariableId\" [dataType]=\"dataType\"></variable-selector> </div> </div> </div> <div *ngIf=\"accessPermission != accessPermissionEnum.ReadOnly\"> <div class=\"fe-radio-select-header\"> <label> <input type=\"checkBox\" (change)=\"useSameVariable()\" [checked]=\"!isSameVariable\" /> <span>{{lc(\"ReadWriteAddressDifferent\")}}</span> </label> <label> <input type=\"checkBox\" (change)=\"useIsPassword()\" [checked]=\"isPassword\" /> <span>{{lc(\"Password\")}}</span> </label> </div> <div class=\"fe-vertical-label\"> <div class=\"fe-vertical-title\">{{lc(\"ReadVariable\")}}:</div> <div class=\"fe-vertical-component\"> <variable-selector [configureId]=\"configureId\" [(currentVariableId)]=\"currentReadVariableId\" [dataType]=\"dataType\"></variable-selector> </div> </div> <div class=\"fe-vertical-label\" *ngIf=\"!isSameVariable\"> <div class=\"fe-vertical-title\">{{lc(\"WriteVariable\")}}:</div> <div class=\"fe-vertical-component\"> <variable-selector [configureId]=\"configureId\" [(currentVariableId)]=\"currentWriteVariableId\" [dataType]=\"dataType\"></variable-selector> </div> </div> <div class=\"fe-vertical-label\" *ngIf=\"hasCharCount\"> <div class=\"fe-vertical-title\">{{lc(\"CharacterLength\")}}:{{charCountNum}}</div> </div> </div> <div class=\"form-group textToolBarPadding margin-top-10\" *ngIf=\"labelInfo&&labelInfo.font\"> <font-style [(fontSize)]=\"labelInfo.font.fontSize\" [(fontColor)]=\"labelInfo.font.color\" [(textAlign)]=\"labelInfo.font.textAlign\" [(isUnderline)]=\"labelInfo.font.isUnderline\" [(fontStyle)]=\"labelInfo.font.fontStyle\"></font-style> </div> <div class=\"fe-vertical-label display-variable-name\"> <label for=\"show-variable-text\"> <input type=\"checkbox\" id=\"show-variable-text\" name=\"show-variable-text\" [(ngModel)]=\"showVariableText\"> <span>{{lc(\"DisplayVariableName\")}}</span> </label> </div> <div class=\"fe-vertical-label margin-bottom-10\" *ngIf=\"showVariableText && variableTextFont\"> <input type=\"text\" name=\"variable-text\" class=\"variable-text-input\" [(ngModel)]=\"variableTextFont.content\" required> <div *ngIf=\"!variableTextFont.content\" class=\"warning-text\">{{lc(\"VariableNameNoEmpty\")}}</div> </div> <div class=\"form-group textToolBarPadding font-padding\" *ngIf=\"showVariableText && variableTextFont\"> <font-setting [font]=\"variableTextFont.font\" [textAlignEnabled]=\"true\"></font-setting> </div> </div> </tab> <tab heading=\"{{lc('Graph')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(graphSettingEventName)\"> <graph-setting [configureId]=\"configureId\" [(useGraph)]=\"useGraph\" [graphSetting]=\"graphSetting\"></graph-setting> </tab> <tab heading=\"{{lc('DynamicSetting')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(dynamicSettingEventName,configureId)\"> <dynamic-conduct [dynamicSetting]=\"dynamicSetting\" [configureId]='configureId' [viewWidth]=\"viewWidth\" [viewHeight]=\"viewHeight\" (validateChange)=\"validateChange($event);\"></dynamic-conduct> </tab> <tab heading=\"{{lc('ControlSetting')}}\" customClass=\"m-tabs__item\" [disabled]=\"accessPermission == accessPermissionEnum.ReadOnly\" (selectTab)=\"tabSelected(controlSettingEventName,configureId)\"> <enable-setting #enableSettingCmp></enable-setting> <control-setting #controlSettingCmp [data]=\"securitySettingData\"></control-setting> </tab> <tab heading=\"{{lc('Display')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(controlSettingEventName,configureId)\"> <display-setting #displaySettingCmp [isFixedPositionVisible]='true'></display-setting> </tab> </tabset> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button type=\"submit\" class=\"fe-btn fe-btn-default fe-btn-save\" [disabled]=\"!characterForm.form.valid || dynamicValidatoinResult || !variableTextFont.content\" [buttonBusy]=\"saving\" [busyText]=\"l('SavingWithThreeDot')\"> {{l(\"Save\")}} </button> <button [disabled]=\"saving\" type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"close()\"> {{l(\"Cancel\")}} </button> </div> </div> </form> </div> </div> </div> </div>"
        }),
        __param(1, Inject(VARIABLE_SERVICE))
    ], CharacterSettingModalComponent);
    return CharacterSettingModalComponent;
}(FontElementSettingModal));
export { CharacterSettingModalComponent };
